<template>
  <div class="paginaNoAccesible">
    <div id="presentacion"></div>
      <div class="altoVacio"> </div>
      <presentacion-no-ac/>
    <div id="sede"></div>   
     <div class="altoVacio"> </div>
      <sede-no-ac/>

    <div id="contacto"></div>
     <div class="altoVacio"> </div>
    <contacto-no-ac/>
    
 </div>
</template>
<script>




import PresentacionNoAc from '../components/PresentacionNoAc.vue'
import SedeNoAc from '../components/SedeNoAc.vue'
import ContactoNoAc from '../components/ContactoNoAc.vue'
/*import Modal from '../components/Modal.vue' */


export default {
  name: 'HomeNA',
  components: {
    PresentacionNoAc,
    SedeNoAc,
    ContactoNoAc,
  }
}



</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.altoVacio {
height: 150px;

}

.paginaNoAccesible a:link, .paginaNoAccesible a:visited, .paginaNoAccesible a:active {
    text-decoration:none;
}

.paginaNoAccesible *:focus { 
outline: none; 
border: none; 
/*border:4px solid transparent;*/
} 
.paginaNoAccesible *:active { 
  outline: none; 
  border: none; }

button.change { 
    background-color: #F88F00; 
    border: none;
    } 




/*
 .paginaNoAccesible a:focus { 
  outline: none; 
 border:1px solid red;} 
*/



</style>